import React, { Component, Fragment } from 'react';
import { BeatLoader } from 'react-spinners';
import { Doughnut } from 'react-chartjs-2';
import NotificationSystem from 'react-notification-system';
import { groupBy, _addNotification, _addNotificationError } from "../../../../server/util";
import moment from 'moment';
import MonthDropdown from '../../../Misc/MonthDropdown';
import { get } from '../../../../server/actions';
import { result } from 'lodash';
var _ = require('lodash');
class catererDoughnut extends Component {
    constructor(props) {
        super(props);
        let date = new Date();
        date.setMonth(date.getMonth())
        this.state = {
            loading: false,
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    formatObject = () => {
        let result = {};
        const schoolList = this.props.schoolList || [];
        const isSchool = this.props.selectSchool == 0 ? false : true;
        if (isSchool) {
            const _countByGrade = (this.props.data.data || {});
            Object.keys(_countByGrade).map(key => {
                result[key] = { count: _countByGrade[key], schoolId: this.props.selectSchool }
            })
        } else {
            const schoolGroup = groupBy(schoolList, 'schoolId');
            Object.keys(this.props.data.data).map(key => {
                const _data = this.props.data.data;
                result[((schoolGroup[key] || [])[0] || {}).schoolName] = { count: _data[key], schoolId: key }
            })
        }
        return result;
    }
    render() {
        const dataObj = this.formatObject();
        let lable = Object.keys(dataObj).map((key) => {
            return key
        })
        const data = {
            labels: lable,
            datasets: [{
                data: Object.values(dataObj).map(value => {
                    return value.count;
                }),
                backgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#CD853F',
                    '#AF6382',
                    '#BC8F8F',
                    '#FFCE55',
                    '#A3A381',
                    '#3672BC',
                    '#FFDEAD',
                    '#FF6380',
                    '#1AAA22',
                    '#FF69B4',
                    '#808080'
                ],
                hoverBackgroundColor: [
                    '#FF6384',
                    '#36A2EB',
                    '#CD853F',
                    '#AF6382',
                    '#BC8F8F',
                    '#FFCE55',
                    '#A3A381',
                    '#3672BC',
                    '#FFDEAD',
                    '#FF6380',
                    '#1AAA22',
                    '#FF69B4',
                    '#808080'
                ]
            }]
        }
        const options = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                position: 'left',
                labels: {
                    boxWidth: 8
                }
            },
            plugins: {
                datalabels: {
                    display: true,
                    color: 'white',
                    font: { size: '10' },
                }
            }
        }
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className="col-md-4">
                    <div className='sweet-loading'
                        style={{ position: 'absolute', top: '50%', left: '48%', zIndex: '1000' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="panel chart-panel">
                        <div className="panel-heading text-center" style={{ padding: '0px' }}>
                            <span className="panel-title" style={{ fontSize: '14px', fontWeight: '600' }}>{'Monthly School Orders'}</span>
                            <div className="pull-right">
                                <MonthDropdown dateFormat={'YYYYMM'} onChange={(e) => {
                                    this.props.onChangeMonth(moment(e));
                                }} selectedMonth={moment(this.props.data.selectedMonth)} />
                            </div>
                            <p className="panel-title" style={{ fontSize: '12px', fontWeight: '600' }}>
                                {this.state.selectedMonth}</p>
                        </div>
                        <div className="panel-body" style={{ padding: '0px' }}>
                            <Doughnut data={data} options={options} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default catererDoughnut


// WEBPACK FOOTER //
// ./src/components/Caterer/Home/dashboard/doghnut.jsx